import { ApiService } from '../ApiService';
import type { User, AuthMeResponse } from '../../../types/auth';
import type { ApiResponse } from '../types';

export const authApi = {
  /**
   * Récupérer le profil utilisateur avec organisation et business unit
   * Endpoint principal pour initialiser le contexte de l'application
   * GET /auth/me
   */
  getMe: (): Promise<ApiResponse<AuthMeResponse>> => 
    ApiService.get<AuthMeResponse>('/auth/me'),

  /**
   * Vérification du token (legacy - utiliser getMe à la place)
   * GET /auth/verify
   */
  verifyToken: () => 
    ApiService.get<{ user: User }>('/auth/verify'),

  /**
   * Déconnexion - invalide la session côté backend
   * POST /auth/logout
   */
  logout: () => 
    ApiService.post<void>('/auth/logout', {}),
    
  /**
   * Connexion avec KS Auth (SSO interne)
   * POST /auth/sso
   */
  loginWithSSO: (): Promise<ApiResponse<{ user: User, token: string }>> => 
    ApiService.post<{ user: User, token: string }>('/auth/sso', {})
};